import React, { useMemo, useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import {
  Avatar,
  Typography
} from "@mui/material";
import camera from '../icons/camera.svg';
import AlertTypeFile from "./AlertTypeFile";
import profileService from "../services/profile.service";
import DialogUploadSucess from "../components/DialogUploadSucess";
import AlertSizeFile from "./AlertSizeFile";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const baseStyle = {
  transition: "all .24s ease-in-out",
};

const activeStyle = {
  borderColor: "#2196f3"
};

const acceptStyle = {
  borderColor: "#00e676"
};

const rejectStyle = {
  borderColor: "#ff1744"
};

const thumbsContainer = {
  display: "flex",
  flexDirection: "row",
  flexWrap: "wrap",
  minWidth: "200px",
  minHeight: "200px",
  borderRadius: "50%"
};

const thumb = {
  display: "inline-flex",
  width: 200,
  height: 200,
};

const thumbInner = {
  display: "flex",
  minWidth: "200px",
  minHeight: "200px",
  overflow: "hidden",
  width: "100%",
  borderRadius: "50%"
};

const img = {
  display: "block",
  width: "100%",
  height: "100%",
  objectFit: "cover"
};
let acceptedFileItemsStatus = false;
let fileRejectionItemsStatus = false;

function UploadImages(props) {
  const { t } = useTranslation();
  const [isAlertFileOpen, openAlertFile] = React.useState(false);
  const [isAlert, openAlert] = React.useState(false);
  const [test, setTest] = React.useState(true);
  const [isSuccessDialogOpen, openConfirmDialog] = React.useState(false);
  const [isAcceptedFileItemsStatus, setAcceptedFileItemsStatus] = React.useState(false);
  const [isFileRejectionItemsStatus, setFileRejectionItemsStatus] = React.useState(false);
  const [files, setFiles] = useState([]);
  const { image } = props;
  const dispatch = useDispatch();
  const handleSubmitFiles = (files) => {
    profileService.uploadFiles(files).then(
      (response) => {
        openConfirmDialog(true)
        openAlert(false)
        handleGetProfile()
        // console.log(response, 777);
      },
    );
  }
  const proxy = JSON.parse(localStorage.getItem("proxy"));
  const dataProfiles = JSON.parse(localStorage.getItem("user"));
  let permission = proxy?.proxy_token !== undefined ? proxy?.permission : dataProfiles?.permission
  const handleGetProfile = () => {
    profileService.profile().then(
      (response) => {
        // console.log({ ...dataProfiles, profile: { ...dataProfiles.profile, photo: response.data.photo } });
        localStorage.setItem("user", JSON.stringify({ ...dataProfiles, profile: { ...dataProfiles.profile, photo: response?.data?.photo } }))
        dispatch({
          type: "LOGIN_SUCCESS",
          payload: { user: { data: { data: { ...dataProfiles, profile: { ...dataProfiles.profile, photo: response?.data?.photo } } } } },
        });
      },
    )
  };
  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
    acceptedFiles,
    fileRejections,
    open
  } = useDropzone({
    // accept: "image/jpg, image/jpeg, image/png",
    noClick: true,
    noKeyboard: true,
    multiple: false,
    // maxFiles: 1,
    // maxSize: 5242880,
    onDrop: acceptedFiles => {
      if (acceptedFileItemsStatus || fileRejectionItemsStatus) {
        openAlertFile(true)
        openAlert(true)
        // setFiles([])
        // console.log(147);
      } else {
        // console.log(300);
        setFiles(
          acceptedFiles.map(file =>
            Object.assign(file, {
              preview: URL.createObjectURL(file),
            }),
          )
        );
        handleSubmitFiles(acceptedFiles)
      }
    },
  });
  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {})
    }),
    [isDragActive, isDragReject]
  );

  const thumbs = files.map(file => (
    <div style={thumb} key={file.name}>
      <div style={thumbInner}>
        {/* <img src={file.preview} style={img} /> */}
        <Avatar
          src={file.preview}
          style={img}
          sx={{
            cursor: "pointer",
            width: 200,
            height: 200,
          }}
        />
      </div>
    </div>
  ));

  useEffect(
    () => () => {
      // Make sure to revoke the data uris to avoid memory leaks
      files.forEach(file => URL.revokeObjectURL(file.preview));
    },
    [files]
  );
  const acceptedFileItems = acceptedFiles.map(file => {
    if (file.size > 5242880) {
      acceptedFileItemsStatus = true
      fileRejectionItemsStatus = false
    } else if (file.type !== "image/jpeg" && file.type !== "image/jpg" && file.type !== "image/png") {
      fileRejectionItemsStatus = true
      acceptedFileItemsStatus = false
    } else {
      acceptedFileItemsStatus = false
      fileRejectionItemsStatus = false
    }
  });
  const update = () => {
    openAlertFile(false);
    // // openAlert(false)
    fileRejectionItemsStatus = false;
    acceptedFileItemsStatus = false;
  }
  return (
    <div className="container" style={{ display: "flex", width: "30%", justifyContent: "center", alignItems: "center", flexFlow: "column" }}>
      <div {...getRootProps({ style })}>
        <input {...getInputProps()} />
        <div {...getRootProps({ style })}>
          <input {...getInputProps()} />
          {permission !== undefined && permission !== null ? permission.filter((item) => item.edit === true && item.code === "profile_photo").length > 0 ?
            thumbs.length === 0 ?
              <Avatar
                src={image}
                style={thumbsContainer}
                sx={{
                  cursor: "pointer",
                  width: 200,
                  height: 200,
                }}
                onClick={open}
              />
              :
              <aside style={thumbsContainer} onClick={open}>{thumbs}</aside>
            :
            <Avatar
              src={image}
              style={thumbsContainer}
              sx={{
                width: 200,
                height: 200,
              }}
            />
            :
            <Avatar
              src={image}
              style={thumbsContainer}
              sx={{
                width: 200,
                height: 200,
              }}
            />
          }
          <div>{acceptedFileItems}</div>
          {/* <div>{fileRejectionItems}</div> */}
          {isAlert ?
            <Typography fontSize={12} lineHeight="21px" color={"#CC6058"} sx={{ textAlign: "center", paddingTop: "10px" }}>{t(`label.uploadFailedPleaseTryAgain`)}</Typography>
            : null
          }
          {permission !== undefined && permission !== null ?
            permission.filter((item) => item.edit === true && item.code === "profile_photo").length > 0 ?
              < div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "20px 0 0 0" }}>
                <img src={camera} alt="camera" />
                <Typography onClick={open} style={{ fontSize: "12px", lineHeight: "17px", color: "#404349", fontWeight: "400", textDecoration: "underline", cursor: "pointer", paddingLeft: "10px" }}>{t(`label.changeProfilePicture`)} </Typography>
              </div>
              : null
            : null
          }
        </div>
        <AlertTypeFile open={isAlertFileOpen} setValue={update} text={t(`label.fileCouldNotBeUploaded`)} />
        <DialogUploadSucess subTitle={"a"} open={isSuccessDialogOpen} setValue={openConfirmDialog} upload={true} text={t(`label.changeProfile`)} />
      </div>
    </div >
  );
}

export default UploadImages;
